import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StoreSalesPerformanceResponse } from '../../../hooks';
import { Typography } from '../../../stories/atoms';
import { DropdownMenu } from '../../../stories/molecules';
import { homeTranslations } from '../../../translations';

type StoreOverviewFiltersProps = {
  salesData: StoreSalesPerformanceResponse | null;
  isLoading: boolean;
  isError: boolean;
  selectedFilter: string | undefined;
  getSelectedIndex: (selectedIndex: string) => void;
};

export const StoreOverviewFilters: FC<StoreOverviewFiltersProps> = ({
  salesData,
  isLoading,
  isError,
  selectedFilter,
  getSelectedIndex,
}) => {
  const { t } = useTranslation();
  const { budgetPlanned } = homeTranslations;
  const [indexOptions, setIndexOptions] = useState<{ index: string; indexDescription: string }[]>([]);

  useEffect(() => {
    if (!salesData) return;
    const allAggregations = [
      ...salesData.currentDay.departmentDetails,
      ...salesData.lastCompleteDay.departmentDetails,
      ...salesData.currentWeek.departmentDetails,
      ...salesData.lastCompleteWeek.departmentDetails,
      ...salesData.lastFourWeeks.departmentDetails,
      ...salesData.accumulatedFinancialYearToDate.departmentDetails,
    ];

    const allIndexes = allAggregations.reduce((acc, { index, indexDescription }) => {
      acc.push({ index, indexDescription });
      return acc;
    }, [] as { index: string; indexDescription: string }[]);

    const uniqueIndexes = Array.from(new Map(allIndexes.map((item) => [item.index, item])).values());
    setIndexOptions(uniqueIndexes);
  }, [salesData]);

  const indexMenuItems = indexOptions.map((item) => {
    return {
      key: item.index,
      item: <Typography margin={[0, 2, 0]}>{item.indexDescription}</Typography>,
    };
  });

  return (
    <DropdownMenu
      dropdownLabel={t(budgetPlanned.indexText.key, budgetPlanned.indexText.defaultValue)}
      menuPosition="left"
      maxHeight={'50vh'}
      menuItems={indexMenuItems}
      initialSelected={[selectedFilter || '']}
      buttonContentProps={{
        isDisabled: !salesData || !indexMenuItems.length || isLoading || isError,
      }}
      onSelect={(selectedItemKeys) => {
        getSelectedIndex(selectedItemKeys[0]);
      }}
    />
  );
};
